require("@PayseraMapBundle/Resources/less/locations-map.less");
require("imports-loader?define=>false!@EvpJsRoutingBundle/Resources/public/js/router.js");
require("@root/web/js/fos_js_routes.js");

import angular from 'angular';

require("imports-loader?define=>false,exports=>false!@root/node_modules/raven-js/dist/plugins/angular.js");
require("@root/assets/js/raven/angular-plugin.js");
require("@root/node_modules/angular/angular-csp.css");
require("@root/node_modules/angular-checkboxes/angular-checkboxes.js");
require("@root/node_modules/ngmap/build/scripts/ng-map.js");

require("@root/node_modules/js-marker-clusterer/src/markerclusterer.js");
require('file-loader?name=[name].[ext]!@root/node_modules/js-marker-clusterer/images/m1.png');
require('file-loader?name=[name].[ext]!@root/node_modules/js-marker-clusterer/images/m2.png');
require('file-loader?name=[name].[ext]!@root/node_modules/js-marker-clusterer/images/m3.png');
require('file-loader?name=[name].[ext]!@root/node_modules/js-marker-clusterer/images/m4.png');
require('file-loader?name=[name].[ext]!@root/node_modules/js-marker-clusterer/images/m5.png');

import appConfig from './app.config';
import appRouting from './app.routing';

import ngRoute from 'angular-route';
import payseraTranslator from '@root/assets/js/module/paysera-translator/app';
import payseraEnvironment from '@root/assets/js/module/paysera-environment/app';
import payseraHttp from '@root/assets/js/module/paysera-http/app';

import locationsMapController from './controller/module.js';
import locationsMapService from './service/module.js';

export default angular
    .module('paysera.locations_map', [
        ngRoute,
        locationsMapController,
        locationsMapService,
        payseraTranslator,
        payseraEnvironment,
        payseraHttp,
        'msieurtoph.ngCheckboxes',
        'ngMap'
    ])
    .config(appConfig)
    .config(appRouting)
;

if (Raven !== undefined && Raven.isSetup()) {
    angular
        .module('paysera.locations_map')
        .requires.push('ngRaven')
    ;
}
